var regexpData = /^aria-/;
function filterAriaAttributes(obj) {
  return Object.keys(obj).filter(function (p) {
    return regexpData.test(p);
  }).reduce(function (acc, p) {
    acc[p] = obj[p];
    return acc;
  }, {});
}

export default filterAriaAttributes;
//# sourceMappingURL=filter-aria-attributes.js.map
